export const COLUMNS = [
  {
    Header: "Name",
    Footer: "Name",
    accessor: (row) => `${row.firstName} ${row.lastName}`
  },
  {
    Header: "Email",
    Footer: "Email",
    accessor: "primaryEmail"
  },
  {
    Header: "Connected Status",
    Footer: "Connected Status",
    accessor: "status"
  }
];
